import { UploadedFile } from '../files/UploadedFile';

export function getBaseFilename(filename: string): string {
  if (filename.indexOf('.') === -1) {
    return filename;
  }

  return filename.split('.').slice(0, -1).join('.');
}

/**
 * Parses a filename to retrieve the extension.
 */
export function getFileExtension(filename: string): string | null {
  if (filename.indexOf('.') === -1) {
    return null;
  }

  return filename.split('.').slice(-1)[0];
}

/**
 * Produces a human-readable filename, in lower case.
 */
export function getFullLowercaseName(file: UploadedFile): string {
  return getFullName(file).toLowerCase();
}

/**
 * Produces a human-readable filename.
 */
export function getFullName(file: UploadedFile): string {
  if (file.filetype == null) {
    return file.filename;
  }

  return `${file.filename}.${file.filetype}`;
}

/**
 * Appends a number to the end of a filename.
 * @example appendNumber('dir/meta.pdf', 4); // => 'dir/meta-4.pdf'
 */
export function appendNumber(filename: string, num: number) {
  if (!filename.includes('.')) {
    return `${filename}-${num}`;
  }

  return `${getBaseFilename(filename)}-${num}.${getFileExtension(filename)}`;
}
